import { NgModule } from '@angular/core';
import {EquityInstallmentComponent} from "./equity-installment.component";
import {MatSidenavModule} from "@angular/material/sidenav";
import { EquityInstallmentDocumentsPanelComponent } from './equity-installment-subcomponents/equity-installment-documents-panel/equity-installment-documents-panel.component';
import { EquityInstallmentHomeComponent } from './equity-installment-subcomponents/equity-installment-home/equity-installment-home.component';
import {MatButtonModule} from "@angular/material/button";
import { EquityInstallmentInstallmentEntryComponent } from './equity-installment-subcomponents/equity-installment-installment-entry/equity-installment-installment-entry.component';
import { EquityInstallmentFundingComponent } from './equity-installment-subcomponents/equity-installment-funding/equity-installment-funding.component';
import {MatExpansionModule} from "@angular/material/expansion";
import {SharedModule} from "../components/shared.module";
import {MatDividerModule} from "@angular/material/divider";
import {CommonModule, CurrencyPipe} from "@angular/common";
import {CdkAccordionModule} from "@angular/cdk/accordion";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import { EquityInstallmentApprovalLogsModalComponent } from './equity-installment-subcomponents/equity-installment-approval-logs-modal/equity-installment-approval-logs-modal.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import { EquityInstallmentConditionsComponent } from './equity-installment-subcomponents/equity-installment-conditions/equity-installment-conditions.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import { EquityInstallmentApprovalComponent } from './equity-installment-subcomponents/equity-installment-approval/equity-installment-approval.component';
import { EquityInstallmentFileComponent } from './equity-installment-subcomponents/equity-installment-file/equity-installment-file.component';
import { AddInstallmentFundingModalComponent } from './equity-installment-subcomponents/add-installment-funding-modal/add-installment-funding-modal.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {CurrencyParserDirective} from "../directives/currency-parser.directive";

@NgModule({
  declarations: [
    EquityInstallmentComponent,
    EquityInstallmentDocumentsPanelComponent,
    EquityInstallmentHomeComponent,
    EquityInstallmentInstallmentEntryComponent,
    EquityInstallmentFundingComponent,
    EquityInstallmentApprovalLogsModalComponent,
    EquityInstallmentConditionsComponent,
    EquityInstallmentApprovalComponent,
    EquityInstallmentFileComponent,
    AddInstallmentFundingModalComponent
  ],
    imports: [
        MatSidenavModule,
        MatButtonModule,
        MatExpansionModule,
        MatBottomSheetModule,
        SharedModule,
        MatDividerModule,
        CommonModule,
        CurrencyPipe,
        CdkAccordionModule,
        FormsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatOptionModule,
        MatRadioModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatTableModule,
        MatSortModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        ClipboardModule,
        CurrencyParserDirective

    ],
  providers: [
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }
  ]
})

export class EquityInstallmentModule {}
